<template>
  <div class="hm-date-select">
    <div class="flex">
      <div
        class="title el-form-item__label"
        v-show="title !== '发放'"
        style="width: 140px"
      >
        <span class="icon">*</span>
        <span>{{ title }}期限：</span>
      </div>
      <div>
        <el-radio-group
          :disabled="isPreview || disableSwitchTime"
          v-model="useImmediately"
          size="small"
        >
          <el-radio :label="2">全时段</el-radio>
          <el-radio :label="1" v-if="title === '使用'">即领即用</el-radio>
          <el-radio :label="0">特定时段</el-radio>
          <el-radio :label="3" v-if="title === '使用'"
            >日期券（测试勿用）</el-radio
          >
        </el-radio-group>

        <div class="deadline hm-form-container">
          <div v-show="useImmediately === 1">
            <span>{{ title }}期限：</span>
            <el-input
              size="small"
              @mousewheel.prevent.native
              clearable
              style="width: 80px"
              class="mr10"
              :class="{ isDisabled: isPreview }"
              type="number"
              :disabled="isPreview"
              v-model.trim="immediatelyEffective"
            ></el-input>
            <span style="width: 80px">小时</span>
            <!-- <el-select size="small" v-model="timeType" style="width: 80px">
              <el-option label="天" :value="0"> </el-option>
              <el-option label="小时" :value="1"> </el-option>
            </el-select> -->
            后生效， 有效期为
            <el-input
              size="small"
              class="mr10"
              style="width: 80px"
              @mousewheel.prevent.native
              clearable
              :class="{ isDisabled: isPreview }"
              type="number"
              :disabled="isPreview"
              v-model.trim="immediatelyEffectiveDays"
            ></el-input>
            <span style="width: 80px">小时</span>

            <!-- <el-select size="small" v-model="timeType" style="width: 80px">
              <el-option label="天" :value="0"> </el-option>
              <el-option label="小时" :value="1"> </el-option>
            </el-select> -->
            <!-- <span class="time-tip">
              {{ tip }}
            </span> -->
          </div>
          <div v-show="useImmediately === 3">
            <span>{{ title }}期限：</span>
            <el-input
              size="small"
              @mousewheel.prevent.native
              clearable
              style="width: 80px"
              class="mr10"
              :class="{ isDisabled: isPreview }"
              type="number"
              :disabled="isPreview"
              v-model.trim="immediatelyEffective"
            ></el-input>
            <span style="width: 80px">天</span>
            <!-- <el-select size="small" v-model="timeType" style="width: 80px">
              <el-option label="天" :value="0"> </el-option>
              <el-option label="小时" :value="1"> </el-option>
            </el-select> -->
            后生效， 有效期为
            <el-input
              size="small"
              class="mr10"
              style="width: 80px"
              @mousewheel.prevent.native
              clearable
              :class="{ isDisabled: isPreview }"
              type="number"
              :disabled="isPreview"
              v-model.trim="immediatelyEffectiveDays"
            ></el-input>
            <span style="width: 80px">天</span>
            <!-- <el-select size="small" v-model="timeType" style="width: 80px">
              <el-option label="天" :value="0"> </el-option>
              <el-option label="小时" :value="1"> </el-option>
            </el-select> -->
            <!-- <span class="time-tip">
              {{ tip }}
            </span> -->
          </div>
          <div class="error" v-show="immediatelyEffective === ''">
            请选择{{ title }}开始时间
          </div>
          <div
            class="error"
            v-show="immediatelyEffectiveDays === '' && useImmediately === 1"
          >
            请选择{{ title }}有效期限
          </div>
          <div class="error" v-show="!isRequiredFormat && useImmediately === 1">
            {{ title }}期限必须为大于或等于0的整数
          </div>

          <div
            class="error"
            v-show="immediatelyEffectiveDays === '' && useImmediately === 3"
          >
            请选择{{ title }}有效期限
          </div>
          <div class="error" v-show="!isRequiredFormat && useImmediately === 3">
            {{ title }}期限必须为大于或等于0的整数
          </div>
          <div
            class="margin-bottom"
            v-show="
              (useImmediately === 0 || title === '发放') && useImmediately !== 2
            "
          >
            {{ title }}日期：
            <el-date-picker
              size="small"
              :disabled="isPreview"
              v-model="ruleDate"
              ref="datepicker"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
          <div
            v-show="
              (useImmediately === 0 || title === '发放') && useImmediately !== 2
            "
          >
            <div class="margin-bottom flex item-center">
              <el-radio-group
                :disabled="isPreview"
                v-model="ruleTimeStrategyType"
                class="margin-right"
                size="small"
              >
                <el-radio-button :label="0">日</el-radio-button>
                <el-radio-button :label="1">周</el-radio-button>
                <el-radio-button :label="2">月</el-radio-button>
              </el-radio-group>
              <div style="flex: 1">
                <div v-if="ruleTimeStrategyType === 0">
                  每：
                  <el-input
                    size="small"
                    @mousewheel.prevent.native
                    clearable
                    :class="{ isDisabled: isPreview }"
                    type="number"
                    :disabled="isPreview"
                    v-model.trim="day"
                  ></el-input>
                  <span class="unit">天</span>
                </div>
                <div v-if="ruleTimeStrategyType === 1" class="flex">
                  每周：
                  <el-checkbox-group
                    :disabled="isPreview"
                    v-model="week"
                    class="flex"
                  >
                    <el-checkbox
                      v-for="(v, i) in weekList"
                      :key="i"
                      :label="v.value"
                      >{{ v.day }}</el-checkbox
                    >
                  </el-checkbox-group>
                </div>
                <div v-if="ruleTimeStrategyType === 2" class="flex">
                  每：
                  <el-checkbox-group
                    :disabled="isPreview"
                    v-model="daysList"
                    class="flex flex-wrap month-check-box-wrapper"
                  >
                    <el-checkbox
                      v-for="(v, i) in monthList"
                      :key="i"
                      :label="v.value"
                      >{{ v.day }}</el-checkbox
                    >
                  </el-checkbox-group>
                </div>
              </div>
            </div>
            <div class="flex">
              <span style="margin-top: .6rem">{{ title }}时间：</span>
              <div>
                <div class="item flex item-center">
                  <div>
                    <el-time-picker
                      size="small"
                      is-range
                      v-model="selectedTime"
                      range-separator="至"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                      placeholder="选择时间范围"
                      :disabled="isPreview"
                    >
                    </el-time-picker>
                    <span
                      class="hmicon icon-jiahao pointer"
                      @click="addtionTime()"
                      style="margin-left: 10px"
                      v-show="
                        selectedTime && selectedTime.length > 0 && !isPreview
                      "
                    ></span>
                  </div>
                  <div></div>
                </div>
              </div>
            </div>
            <div class="flex">
              <span>已选时间：</span>
              <div style="width:384px" class="time-list">
                <div
                  v-for="(item, i) in timeList"
                  :key="i"
                  class="time-list-item"
                >
                  <div class="time flex flex-between">
                    <div class="time-wrapper">
                      <span>{{ item.start || item.sendStartTime }}</span>
                      <span class="margin">至</span>
                      <span>{{ item.end || item.sendEndTime }}</span>
                    </div>
                    <span
                      class="hmicon icon-jianhao pointer"
                      @click="deleteTime(i)"
                      style="margin-left: 10px"
                      v-show="!isPreview"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="useImmediately === 2 && multipleTime">
            <el-date-picker
              v-model="ruleDateAndTime"
              type="datetimerange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              :disabled="isPreview"
              size="small"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </div>
        </div>
        <div
          class="error"
          v-show="
            useImmediately === 2 && (ruleDateAndTime === '' || !ruleDateAndTime)
          "
        >
          请选择{{ title }}日期
        </div>
        <div
          class="error"
          v-show="
            (useImmediately === 0 && !ruleDate) ||
              (useImmediately === 0 && title === '发放' && !ruleDate)
          "
        >
          请选择{{ title }}日期
        </div>
        <div
          class="error"
          v-show="
            (useImmediately === 0 &&
              ruleTimeStrategyType === 0 &&
              day === '') ||
              (useImmediately === 0 &&
                title === '发放' &&
                ruleTimeStrategyType === 0 &&
                day === '')
          "
        >
          请选择{{ title }}日
        </div>
        <div
          class="error"
          v-show="
            (useImmediately === 0 && ruleTimeStrategyType === 0 && day <= 0) ||
              (useImmediately === 0 &&
                title === '发放' &&
                ruleTimeStrategyType === 0 &&
                day <= 0)
          "
        >
          日必须为大于0的数
        </div>
        <div
          class="error"
          v-show="
            (useImmediately === 0 &&
              ruleTimeStrategyType === 1 &&
              week.length <= 0) ||
              (useImmediately === 0 &&
                title === '发放' &&
                ruleTimeStrategyType === 1 &&
                week.length <= 0)
          "
        >
          请选择{{ title }}周
        </div>
        <div
          class="error"
          v-show="
            (useImmediately === 0 &&
              ruleTimeStrategyType === 2 &&
              daysList.length <= 0) ||
              (useImmediately === 0 &&
                title === '发放' &&
                ruleTimeStrategyType === 2 &&
                daysList.length <= 0)
          "
        >
          请选择{{ title }}月
        </div>
        <div
          class="error"
          v-show="
            (useImmediately === 0 && timeList.length <= 0) ||
              (useImmediately === 0 && title === '发放' && timeList.length <= 0)
          "
        >
          请选择{{ title }}时间
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: {
    title: { type: String },
    isPreview: { type: Boolean },
    multipleTime: { type: Boolean },
    disableSwitchTime: { type: Boolean }
  },
  data() {
    const month = [];
    for (let i = 1; i < 32; i++) {
      month.push({ day: i < 10 ? "0" + i : i, value: i });
    }
    const immediatelyEffective = 1;
    return {
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          // 应运营部要求多加一天
          // #I8RQF8 将限制时间增加到13个月
          let day = (365 + 2 + 30) * 24 * 3600 * 1000;
          let dateRegion = curDate + day;

          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() >= dateRegion
          );
        }
      },
      immediatelyEffectiveDays: 1,
      timeType: 1,
      useImmediately: this.multipleTime ? 0 : 1,
      ruleDate: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
      selectedWeek: [],
      selectedMonth: [],
      day: 1,
      week: [],
      daysList: [],
      tip: "",
      isRequiredFormat: true,
      selectedTime: [
        new Date(2016, 9, 10, 0, 0, 0),
        new Date(2016, 9, 10, 23, 59, 59)
      ],
      ruleDateAndTime: "",
      ruleTimeStrategyType: 0,
      timeList: [{ start: "00:00:00", end: "23:59:59" }],
      immediatelyEffective,
      weekList: [
        {
          day: "日",
          value: "星期日"
        },
        {
          day: "一",
          value: "星期一"
        },
        {
          day: "二",
          value: "星期二"
        },
        {
          day: "三",
          value: "星期三"
        },
        {
          day: "四",
          value: "星期四"
        },
        {
          day: "五",
          value: "星期五"
        },
        {
          day: "六",
          value: "星期六"
        }
      ],
      monthList: month
    };
  },
  created() {
    if (this.timeType === 0) {
      this.tip = `等于${this.immediatelyEffective * 24}小时`;
    } else {
      this.tip = `${
        Number.isInteger(this.immediatelyEffective / 24)
          ? "等于" + this.immediatelyEffective / 24
          : "约等于" + (this.immediatelyEffective / 24).toFixed(2)
      }天`;
    }
    if (this.multipleTime) {
      this.useImmediately = 2;
    }
  },
  watch: {
    ruleDateAndTime(val) {
      this.$emit("switchRuleDateAndTime", val);
    },
    timeType(val) {
      if (val === 0) {
        this.tip = `等于${this.immediatelyEffective * 24}小时`;
      } else {
        this.tip = `${
          Number.isInteger(this.immediatelyEffective / 24)
            ? "等于" + this.immediatelyEffective / 24
            : "约等于" + (this.immediatelyEffective / 24).toFixed(2)
        }天`;
      }
      this.$emit("switchTimeType", val);
    },
    immediatelyEffective(value) {
      const val = Number(value);
      if (Number.isInteger(val) && val >= 0) {
        this.isRequiredFormat = true;
      } else {
        this.isRequiredFormat = false;
      }
      if (this.timeType === 0) {
        this.tip = `等于${value * 24}小时`;
      } else {
        this.tip = `${
          Number.isInteger(value / 24)
            ? "等于" + value / 24
            : "约等于" + (value / 24).toFixed(2)
        }天`;
      }
      if (this.useImmediately !== 0) {
        // this.$emit("switchUseIntime", value);
      }
    },
    immediatelyEffectiveDays(value) {
      const val = Number(value);
      if (Number.isInteger(val) && val >= 1) {
        this.isRequiredFormat = true;
      } else {
        this.isRequiredFormat = false;
      }
      this.$emit("switchUseIntime", value);
    },
    useImmediately(val) {
      console.log("val: ", val);
      if (val === 0) {
        this.immediatelyEffective = 1;
        this.isRequiredFormat = true;
      }
      if (val === 3) {
        this.timeType = 0;
      } else if (val === 1) {
        this.timeType = 1;
      }
      this.$emit("switchUseImmediately", val);
    },
    ruleDate(val) {
      this.$emit("switchRuleDate", val);
    },
    ruleTimeStrategyType(val) {
      if (val === 0) {
        this.week = [];
        this.daysList = [];
        this.day = 1;
      } else if (val === 1) {
        this.day = "";
        this.daysList = [];
      } else if (val === 2) {
        this.day = "";
        this.week = [];
      }
    }
  },
  methods: {
    addtionTime() {
      const start = moment(this.selectedTime[0]).format("HH:mm:ss");
      const end = moment(this.selectedTime[1]).format("HH:mm:ss");
      this.timeList.push({ start, end });
      this.$emit("addUseTime", this.timeList);
    },
    deleteTime(i) {
      this.timeList.splice(i, 1);
      this.$emit("deleteUseTime", this.timeList);
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  font-weight: 700;
}
.month-check-box-wrapper {
  width: 30%;
}
.deadline {
  margin-top: 0.5rem;
  input[type="number"] {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 36px;
    line-height: 36px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 150px;
    text-align: left;
  }
  input[type="number"]:focus {
    border-color: #409eff;
    outline: 0;
  }
}
.time-wrapper {
  flex: 1;
  text-align: center;
  padding-right: 10px;
  font-size: 14px;
}
.time {
  line-height: 1.5rem;
}
.margin {
  margin: 0 2.5rem 0 2.5rem;
}

.margin-bottom {
  margin-bottom: 10px;
}
.margin-right {
  margin-right: 10px;
}
.item {
  margin-bottom: 10px;
}
.icon {
  color: #e4393c;
}

.unit {
  margin-left: 0.5rem;
}

.error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}

.time-tip {
  margin-left: 10px;
  font-size: 0.8rem;
  color: #666;
}

.hm-date-select {
  font-size: 14px;
}

.time-list-item:not(:last-child) {
  margin-bottom: 10px;
}
</style>
